// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MRck","title":"styles_title__lvW9E"};